(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Aphly-Marquee"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA MARQUEE — keeps scroll speed consistent (pixels/second) no matter
   how many words are added. Pure vanilla, no libraries. Falls back to the CSS
   duration if JS is unavailable or motion is reduced.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function size(section) {
    if (reduce) return;
    var track = section.querySelector('.evx-mq__track');
    if (!track) return;
    var pps = parseFloat(section.getAttribute('data-pps')) || 60;
    // The animation travels 50% of the track width per cycle.
    var distance = track.scrollWidth / 2;
    if (!distance) return;
    var duration = distance / pps;               // seconds = px / (px per second)
    track.style.animationDuration = duration.toFixed(2) + 's';
  }

  function init(section) {
    if (!section || section.dataset.evxMqReady) return;
    section.dataset.evxMqReady = 'true';

    // Fonts change metrics after load — recalc when they're ready.
    size(section);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { size(section); });
    }
    window.addEventListener('load', function () { size(section); });

    // Recalculate on resize (debounced).
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { size(section); }, 180);
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.evx-mq').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the Theme Editor when re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-mq');
    if (el) { delete el.dataset.evxMqReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Eleveia-Reassurance"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA REASSURANCE / FAQ — mobile slider dots. Vanilla, no libraries.
   Dots track the active card while swiping and jump to a card when tapped.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.empReady) return;
    section.dataset.empReady = 'true';

    setupReveal(section);
    setupSlider(section);
  }

  /* Scroll reveal (fade-up) */
  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') { return; }
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Mobile slider + pagination dots */
  function setupSlider(section) {
    var scroller = section.querySelector('.evx-emp__cards');
    var cards = section.querySelectorAll('.evx-emp__card');
    var dots  = section.querySelectorAll('.evx-emp__dot');
    if (!scroller || cards.length < 2 || !dots.length) return;

    var setActive = function (i) {
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };

    // Nearest card to the scroller's centre = active
    var currentIndex = function () {
      var center = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var cc = c.offsetLeft + c.clientWidth / 2;
        var d = Math.abs(cc - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(currentIndex()); ticking = false; });
    }, { passive: true });

    // Tap a dot -> centre that card
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        var card = cards[i];
        if (!card) return;
        var left = card.offsetLeft - (scroller.clientWidth - card.clientWidth) / 2;
        scroller.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
      });
    });

    setActive(0);
    window.addEventListener('resize', function () { setActive(currentIndex()); }, { passive: true });
  }

  function boot() { document.querySelectorAll('.evx-emp').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-emp');
    if (el) { delete el.dataset.empReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA COLLECTION GRID — scroll reveal only. Vanilla JS, no libraries.
   Equal card heights are handled entirely in CSS, so there is no layout JS
   to jank or fight the browser.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.cgReady) return;
    section.dataset.cgReady = 'true';

    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -4% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function boot() { document.querySelectorAll('.evx-cg').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-cg');
    if (el) { delete el.dataset.cgReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-faqs"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA FAQs — reveal + smooth accordion. Vanilla JS, no libraries.
   The markup is <details>/<summary>, so everything still works without JS;
   this only adds height animation and the "one open at a time" behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section || section.dataset.fqReady) return;
    section.dataset.fqReady = 'true';
    setupReveal(section);
    setupAccordion(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupAccordion(section) {
    var items = section.querySelectorAll('.evx-fq__item');
    if (!items.length) return;
    var singleOpen = section.getAttribute('data-single-open') === 'true';

    items.forEach(function (item) {
      var summary = item.querySelector('.evx-fq__q');
      var wrap = item.querySelector('.evx-fq__a-wrap');
      if (!summary || !wrap) return;

      // Start collapsed/expanded to match the `open` attribute
      wrap.style.height = item.open ? 'auto' : '0px';

      summary.addEventListener('click', function (e) {
        e.preventDefault(); // we control open/close ourselves for smoothness

        if (item.open) {
          collapse(item, wrap);
        } else {
          if (singleOpen) {
            items.forEach(function (other) {
              if (other !== item && other.open) {
                collapse(other, other.querySelector('.evx-fq__a-wrap'));
              }
            });
          }
          expand(item, wrap);
        }
      });
    });
  }

  function expand(item, wrap) {
    item.open = true;
    if (reduce) { wrap.style.height = 'auto'; return; }
    var target = wrap.scrollHeight;
    wrap.style.height = '0px';
    // force reflow so the transition runs
    void wrap.offsetHeight;
    wrap.style.transition = 'height .38s cubic-bezier(.22,.61,.36,1)';
    wrap.style.height = target + 'px';
    var done = function () {
      wrap.style.transition = '';
      wrap.style.height = 'auto';
      wrap.removeEventListener('transitionend', done);
    };
    wrap.addEventListener('transitionend', done);
  }

  function collapse(item, wrap) {
    if (!wrap) { item.open = false; return; }
    if (reduce) { item.open = false; wrap.style.height = '0px'; return; }
    var start = wrap.scrollHeight;
    wrap.style.height = start + 'px';
    void wrap.offsetHeight;
    wrap.style.transition = 'height .34s cubic-bezier(.22,.61,.36,1)';
    wrap.style.height = '0px';
    var done = function () {
      item.open = false;
      wrap.style.transition = '';
      wrap.removeEventListener('transitionend', done);
    };
    wrap.addEventListener('transitionend', done);
  }

  function boot() { document.querySelectorAll('.evx-fq').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-fq');
    if (el) { delete el.dataset.fqReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-feature-rows"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA ALTERNATING ROWS — reveal + play-in-view for every row video.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.altReady) return;
    section.dataset.altReady = 'true';
    setupReveal(section);
    setupVideos(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupVideos(section) {
    var videos = section.querySelectorAll('video.evx-alt__el');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function(){}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { io.observe(v); });
  }

  function boot() { document.querySelectorAll('.evx-alt').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-alt');
    if (el) { delete el.dataset.altReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-footer"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA FOOTER — reveal + mobile accordion state. Vanilla JS.
   Link columns are <details>, open on desktop and collapsible on mobile.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = '(max-width: 720px)';

  function init(footer) {
    if (!footer || footer.dataset.ftReady) return;
    footer.dataset.ftReady = 'true';
    setupReveal(footer);
    setupAccordion(footer);
  }

  function setupReveal(footer) {
    if (footer.getAttribute('data-animate') !== 'true') return;
    var items = footer.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* On mobile (when enabled) collapse the link groups; always open on desktop */
  function setupAccordion(footer) {
    if (!footer.classList.contains('evx-ft--m-accordion')) return;
    var groups = footer.querySelectorAll('.evx-ft__group');
    if (!groups.length) return;
    var mq = window.matchMedia(MOBILE);

    var apply = function () {
      groups.forEach(function (g) {
        if (mq.matches) {
          // collapse by default on mobile, but leave a user-opened one alone
          if (!g.dataset.userToggled) g.open = false;
        } else {
          g.open = true;
        }
      });
    };

    groups.forEach(function (g) {
      var head = g.querySelector('.evx-ft__group-head');
      if (!head) return;
      head.addEventListener('click', function (e) {
        if (!mq.matches) { e.preventDefault(); return; }   // no toggling on desktop
        g.dataset.userToggled = 'true';
      });
    });

    apply();
    if (mq.addEventListener) { mq.addEventListener('change', apply); }
    else if (mq.addListener) { mq.addListener(apply); }
  }

  function boot() { document.querySelectorAll('.evx-ft').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-ft');
    if (el) { delete el.dataset.ftReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-guarantee-split"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA GUARANTEE SPLIT — scroll reveal. Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.gsReady) return;
    section.dataset.gsReady = 'true';

    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function boot() { document.querySelectorAll('.evx-gs').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-gs');
    if (el) { delete el.dataset.gsReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-guarantee"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA GUARANTEE — scroll reveal. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';
  function init(section) {
    if (!section || section.dataset.gtReady) return;
    section.dataset.gtReady = 'true';
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
  function boot() { document.querySelectorAll('.evx-gt').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-gt');
    if (el) { delete el.dataset.gtReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-hero-banner"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA FULL-BLEED HERO — reveal, ripple and a very subtle parallax.
   Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section || section.dataset.bhReady) return;
    section.dataset.bhReady = 'true';
    setupReveal(section);
    setupRipple(section);
    setupParallax(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') {
      section.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupRipple(section) {
    section.querySelectorAll('[data-ripple]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var rect = btn.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var span = document.createElement('span');
        span.className = 'evx-ripple';
        span.style.width = span.style.height = size + 'px';
        span.style.left = (e.clientX - rect.left - size / 2) + 'px';
        span.style.top  = (e.clientY - rect.top  - size / 2) + 'px';
        btn.appendChild(span);
        setTimeout(function () { span.remove(); }, 620);
      });
    });
  }

  /* Gentle background drift while the hero is on screen */
  function setupParallax(section) {
    if (reduce || !section.classList.contains('evx-bh--parallax')) return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    var imgs = section.querySelectorAll('.evx-bh__img');
    if (!imgs.length) return;

    var ticking = false;
    var apply = function () {
      var rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) { ticking = false; return; }
      var progress = rect.top / window.innerHeight;      // 0 at top of screen
      var shift = (progress * 22).toFixed(2);            // max ~22px, very subtle
      imgs.forEach(function (img) {
        img.style.transform = 'scale(1.06) translate3d(0,' + shift + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }

  function boot() { document.querySelectorAll('.evx-bh').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-bh');
    if (el) { delete el.dataset.bhReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-hero"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA HERO — modular vanilla JS. No libraries. Runs once per section type;
   iterates over every instance. All config is read from data-* attributes.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.evxReady) return;
    root.dataset.evxReady = 'true';

    var animate  = root.dataset.animate === 'true' && !reduceMotion;
    var parallax = root.dataset.parallax === 'true' && !reduceMotion;

    setupRipple(root);
    if (animate) { setupReveal(root); setupCounters(root); }
    else { showAll(root); }
    if (parallax) setupParallax(root);
  }

  /* --- Scroll reveal via IntersectionObserver ----------------------------- */
  function setupReveal(root) {
    var items = root.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) { showAll(root); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function showAll(root) {
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* --- Counter animation (rating counts up once visible) ------------------ */
  function setupCounters(root) {
    var els = root.querySelectorAll('[data-count]');
    if (!els.length) return;
    var run = function (el) {
      var target   = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
      var start = null, dur = 1400;
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Button ripple ------------------------------------------------------- */
  function setupRipple(root) {
    root.querySelectorAll('[data-evx-ripple]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var rect = btn.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var span = document.createElement('span');
        span.className = 'evx-ripple';
        span.style.width = span.style.height = size + 'px';
        span.style.left = (e.clientX - rect.left - size / 2) + 'px';
        span.style.top  = (e.clientY - rect.top  - size / 2) + 'px';
        btn.appendChild(span);
        setTimeout(function () { span.remove(); }, 620);
      });
    });
  }

  /* --- Very subtle parallax on the media block ---------------------------- */
  function setupParallax(root) {
    var el = root.querySelector('[data-evx-parallax]');
    if (!el || !window.matchMedia('(pointer: fine)').matches) return;
    var ticking = false;
    var apply = function () {
      var rect = el.getBoundingClientRect();
      var mid  = rect.top + rect.height / 2;
      var off  = (mid - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translateY(' + (off * -14).toFixed(2) + 'px)';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }

  /* --- Boot --------------------------------------------------------------- */
  function boot() {
    document.querySelectorAll('.evx').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the Theme Editor when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx');
    if (el) { delete el.dataset.evxReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-how-it-works"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA HOW IT WORKS — reveal + play-in-view video. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.hiwReady) return;
    section.dataset.hiwReady = 'true';
    setupReveal(section);
    setupVideo(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupVideo(section) {
    var video = section.querySelector('video.evx-hiw__video');
    if (!video) return;
    var tryPlay = function () {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { tryPlay(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? tryPlay() : video.pause(); });
    }, { threshold: 0.25 });
    io.observe(video);
  }

  function boot() { document.querySelectorAll('.evx-hiw').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-hiw');
    if (el) { delete el.dataset.hiwReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-icon-features"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA ICON FEATURES — reveal + mobile slider dots. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';
  function init(section) {
    if (!section || section.dataset.igReady) return;
    section.dataset.igReady = 'true';
    setupReveal(section);
    section.querySelectorAll('[data-slider-group]').forEach(setupSlider);
  }
  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
  function setupSlider(group) {
    var scroller = group.querySelector('.evx-ig__cards');
    var cards = group.querySelectorAll('.evx-ig__card');
    var dots  = group.querySelectorAll('.evx-ig__dot');
    if (!scroller || cards.length < 2 || !dots.length) return;
    var setActive = function (i) {
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };
    var currentIndex = function () {
      var center = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var cc = c.offsetLeft + c.clientWidth / 2;
        var d = Math.abs(cc - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };
    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(currentIndex()); ticking = false; });
    }, { passive: true });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        var card = cards[i];
        if (!card) return;
        var left = card.offsetLeft - (scroller.clientWidth - card.clientWidth) / 2;
        scroller.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
      });
    });
    setActive(0);
    window.addEventListener('resize', function () { setActive(currentIndex()); }, { passive: true });
  }
  function boot() { document.querySelectorAll('.evx-ig').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-ig');
    if (el) { delete el.dataset.igReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-image-feature"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA IMAGE FEATURE — scroll reveal. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';
  function init(section) {
    if (!section || section.dataset.imgReady) return;
    section.dataset.imgReady = 'true';
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
  function boot() { document.querySelectorAll('.evx-img').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-img');
    if (el) { delete el.dataset.imgReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-product-spotlight"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA PRODUCT SPOTLIGHT — scroll reveal. Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.psReady) return;
    section.dataset.psReady = 'true';

    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function boot() { document.querySelectorAll('.evx-ps').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-ps');
    if (el) { delete el.dataset.psReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-results-gallery"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA RESULTS GALLERY — arrows, dots and optional slow auto-advance.
   Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section || section.dataset.rgReady) return;
    section.dataset.rgReady = 'true';
    setupReveal(section);
    setupCarousel(section);
  }

  function setupReveal(section) {
    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupCarousel(section) {
    var track = section.querySelector('[data-track]');
    var slides = section.querySelectorAll('[data-slide]');
    var dots = section.querySelectorAll('[data-dot]');
    var prev = section.querySelector('[data-prev]');
    var next = section.querySelector('[data-next]');
    if (!track || slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    var loop = section.getAttribute('data-loop') === 'true';
    var timer = null;
    var stopped = false;

    var current = function () {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, dist = Infinity;
      slides.forEach(function (sl, i) {
        var c = sl.offsetLeft + sl.clientWidth / 2;
        var d = Math.abs(c - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };

    var goTo = function (i) {
      if (i < 0) i = loop ? slides.length - 1 : 0;
      if (i > slides.length - 1) i = loop ? 0 : slides.length - 1;
      var sl = slides[i];
      if (!sl) return;
      var left = sl.offsetLeft - (track.clientWidth - sl.clientWidth) / 2;
      track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    };

    var sync = function () {
      var i = current();
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (!loop) {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    function stopAuto() { stopped = true; if (timer) { clearInterval(timer); timer = null; } }
    function startAuto() {
      if (stopped || reduce) return;
      if (section.getAttribute('data-autoplay') !== 'true') return;
      var secs = parseFloat(section.getAttribute('data-interval')) || 5;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (document.hidden) return;
        var i = current();
        if (!loop && i >= slides.length - 1) { clearInterval(timer); timer = null; return; }
        goTo(i + 1);
      }, secs * 1000);
    }

    if (prev) prev.addEventListener('click', function () { stopAuto(); goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { stopAuto(); goTo(current() + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { stopAuto(); goTo(parseInt(d.getAttribute('data-dot'), 10) || 0); });
    });

    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { stopAuto(); goTo(current() + 1); }
      if (e.key === 'ArrowLeft')  { stopAuto(); goTo(current() - 1); }
    });

    section.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
    section.addEventListener('mouseleave', function () { if (!stopped) startAuto(); });
    track.addEventListener('touchstart', function () { if (timer) { clearInterval(timer); timer = null; } }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { startAuto(); }
          else if (timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    } else { startAuto(); }

    sync();
    window.addEventListener('resize', sync, { passive: true });
  }

  function boot() { document.querySelectorAll('.evx-rg').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-rg');
    if (el) { delete el.dataset.rgReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-results-timeline"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA RESULTS TIMELINE — reveal + mobile slider dots. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.tlReady) return;
    section.dataset.tlReady = 'true';
    setupReveal(section);
    setupSlider(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupSlider(section) {
    var scroller = section.querySelector('.evx-tl__cards');
    var cards = section.querySelectorAll('.evx-tl__card');
    var dots  = section.querySelectorAll('.evx-tl__dot');
    if (!scroller || cards.length < 2 || !dots.length) return;

    var setActive = function (i) {
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };
    var currentIndex = function () {
      var center = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var cc = c.offsetLeft + c.clientWidth / 2;
        var d = Math.abs(cc - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(currentIndex()); ticking = false; });
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        var card = cards[i];
        if (!card) return;
        var left = card.offsetLeft - (scroller.clientWidth - card.clientWidth) / 2;
        scroller.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
      });
    });

    setActive(0);
    window.addEventListener('resize', function () { setActive(currentIndex()); }, { passive: true });
  }

  function boot() { document.querySelectorAll('.evx-tl').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-tl');
    if (el) { delete el.dataset.tlReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-stats-bar"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA STATS BAR — reveal + count-up numbers. Vanilla JS, no libraries.
   The count-up parses whatever you typed ("30", "2.4", "180") and animates to
   it, preserving decimals and any thousands separators.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section || section.dataset.stReady) return;
    section.dataset.stReady = 'true';
    setupReveal(section);
    setupCounters(section);
  }

  function setupReveal(section) {
    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupCounters(section) {
    if (section.getAttribute('data-count') !== 'true' || reduce) return;
    var nums = section.querySelectorAll('.evx-st__num');
    if (!nums.length) return;

    var run = function (el) {
      var raw = (el.textContent || '').trim();
      var clean = raw.replace(/,/g, '');
      var target = parseFloat(clean);
      if (isNaN(target)) return;                       // not a number — leave as-is

      var decimals = (clean.split('.')[1] || '').length;
      var hasComma = raw.indexOf(',') > -1;
      var format = function (n) {
        var out = n.toFixed(decimals);
        if (hasComma) {
          var parts = out.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          out = parts.join('.');
        }
        return out;
      };

      var start = null;
      var dur = 1500;
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);            // ease-out cubic
        el.textContent = format(target * eased);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = format(target);
      };
      requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { io.observe(el); });
  }

  function boot() { document.querySelectorAll('.evx-st').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-st');
    if (el) { delete el.dataset.stReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA UGC CAROUSEL — arrows, dots, slow auto-advance, and per-slide
   video playback (autoplay-in-view or tap-to-play, with sound toggle).
   Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section || section.dataset.ugReady) return;
    section.dataset.ugReady = 'true';
    setupReveal(section);
    setupCarousel(section);
    setupVideos(section);
  }

  /* ---------------------------- Reveal ----------------------------------- */
  function setupReveal(section) {
    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------- Carousel ---------------------------------- */
  function setupCarousel(section) {
    var track = section.querySelector('[data-track]');
    var slides = section.querySelectorAll('[data-slide]');
    var dots = section.querySelectorAll('[data-dot]');
    var prev = section.querySelector('[data-prev]');
    var next = section.querySelector('[data-next]');
    if (!track || slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    var loop = section.getAttribute('data-loop') === 'true';

    var current = function () {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, dist = Infinity;
      slides.forEach(function (sl, i) {
        var c = sl.offsetLeft + sl.clientWidth / 2;
        var d = Math.abs(c - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };

    var goTo = function (i) {
      if (i < 0) i = loop ? slides.length - 1 : 0;
      if (i > slides.length - 1) i = loop ? 0 : slides.length - 1;
      var sl = slides[i];
      if (!sl) return;
      var left = sl.offsetLeft - (track.clientWidth - sl.clientWidth) / 2;
      track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    };

    var sync = function () {
      var i = current();
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (!loop) {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { stopAuto(); goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { stopAuto(); goTo(current() + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        stopAuto();
        goTo(parseInt(d.getAttribute('data-dot'), 10) || 0);
      });
    });

    // Keyboard support
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { stopAuto(); goTo(current() + 1); }
      if (e.key === 'ArrowLeft')  { stopAuto(); goTo(current() - 1); }
    });

    /* ---- Slow auto-advance ---- */
    var timer = null;
    var stopped = false;

    function stopAuto() {
      stopped = true;
      if (timer) { clearInterval(timer); timer = null; }
    }
    function startAuto() {
      if (stopped || reduce) return;
      if (section.getAttribute('data-autoplay') !== 'true') return;
      var secs = parseFloat(section.getAttribute('data-interval')) || 5;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (document.hidden) return;
        var i = current();
        if (!loop && i >= slides.length - 1) { clearInterval(timer); timer = null; return; }
        goTo(i + 1);
      }, secs * 1000);
    }

    // Pause while hovering or touching, resume after
    section.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
    section.addEventListener('mouseleave', function () { if (!stopped) startAuto(); });
    track.addEventListener('touchstart', function () { if (timer) { clearInterval(timer); timer = null; } }, { passive: true });

    // Only run autoplay while the section is on screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { startAuto(); }
          else if (timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    } else {
      startAuto();
    }

    sync();
    window.addEventListener('resize', sync, { passive: true });
  }

  /* ----------------------------- Videos ---------------------------------- */
  function setupVideos(section) {
    var videos = section.querySelectorAll('[data-video]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      var slide = video.closest('[data-slide]');
      var playBtn = slide ? slide.querySelector('[data-play]') : null;
      var soundBtn = slide ? slide.querySelector('[data-sound]') : null;

      var mark = function () {
        if (!slide) return;
        slide.classList.toggle('is-playing', !video.paused);
        slide.classList.toggle('is-unmuted', !video.muted);
      };
      video.addEventListener('play', mark);
      video.addEventListener('pause', mark);
      video.addEventListener('volumechange', mark);

      var tryPlay = function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // Browsers block unmuted autoplay — fall back to muted.
            video.muted = true;
            var p2 = video.play();
            if (p2 && p2.catch) p2.catch(function () {});
          });
        }
      };

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) { tryPlay(); } else { video.pause(); }
        });
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          if (!video.muted && video.paused) tryPlay();
          mark();
        });
      }

      // Autoplay in view (only for videos marked to autoplay)
      if (video.dataset.auto === 'true' && !reduce) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { tryPlay(); } else { video.pause(); }
            });
          }, { threshold: 0.35 });
          io.observe(video);
        } else {
          tryPlay();
        }
      }
      mark();
    });
  }

  function boot() { document.querySelectorAll('.evx-ug').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-ug');
    if (el) { delete el.dataset.ugReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-verdict-reviews"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA VERDICT — reveal + multiple sliders (reviews & videos) with dots
   + play-in-view for UGC videos. Vanilla JS.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.vdReady) return;
    section.dataset.vdReady = 'true';
    setupReveal(section);
    section.querySelectorAll('[data-slider-group]').forEach(setupSlider);
    setupVideos(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupSlider(group) {
    var scroller = group.querySelector('.evx-vd__track');
    var cards = group.querySelectorAll('.evx-vd__track > *');
    var dots  = group.querySelectorAll('.evx-vd__dot');
    if (!scroller || cards.length < 2 || !dots.length) return;

    var setActive = function (i) {
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };
    var currentIndex = function () {
      var center = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var cc = c.offsetLeft + c.clientWidth / 2;
        var d = Math.abs(cc - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };
    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(currentIndex()); ticking = false; });
    }, { passive: true });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        var card = cards[i];
        if (!card) return;
        var left = card.offsetLeft - (scroller.clientWidth - card.clientWidth) / 2;
        scroller.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
      });
    });
    setActive(0);
    window.addEventListener('resize', function () { setActive(currentIndex()); }, { passive: true });
  }

  function setupVideos(section) {
    var videos = section.querySelectorAll('video.evx-vd__video-el');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function(){}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        else { v.pause(); }
      });
    }, { threshold: 0.2 });
    videos.forEach(function (v) { io.observe(v); });
  }

  function boot() { document.querySelectorAll('.evx-vd').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-vd');
    if (el) { delete el.dataset.vdReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-video-feature"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA VIDEO FEATURE — reveal + smart video playback (play in view only).
   Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.featReady) return;
    section.dataset.featReady = 'true';
    setupReveal(section);
    setupVideo(section);
  }

  function setupReveal(section) {
    if (section.getAttribute('data-animate') !== 'true') return;
    var items = section.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Play the video only while it's visible; pause when it leaves the screen. */
  function setupVideo(section) {
    var video = section.querySelector('video.evx-feat__video');
    if (!video) return;

    var tryPlay = function () {
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    };

    if (!('IntersectionObserver' in window)) { tryPlay(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { tryPlay(); }
        else { video.pause(); }
      });
    }, { threshold: 0.25 });
    io.observe(video);
  }

  function boot() { document.querySelectorAll('.evx-feat').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-feat');
    if (el) { delete el.dataset.featReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eleveia-viral-social"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA VIRAL SOCIAL CAROUSEL — arrows, dots, slow auto-advance and
   per-slide video playback. Vanilla JS, no libraries.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section || section.dataset.vrReady) return;
    section.dataset.vrReady = 'true';
    setupReveal(section);
    setupCarousel(section);
    setupVideos(section);
  }

  function setupReveal(section) {
    var items = section.querySelectorAll('[data-reveal]');
    if (section.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupCarousel(section) {
    var track = section.querySelector('[data-track]');
    var slides = section.querySelectorAll('[data-slide]');
    var dots = section.querySelectorAll('[data-dot]');
    var prev = section.querySelector('[data-prev]');
    var next = section.querySelector('[data-next]');
    if (!track || slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    var loop = section.getAttribute('data-loop') === 'true';
    var timer = null;
    var stopped = false;

    var current = function () {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, dist = Infinity;
      slides.forEach(function (sl, i) {
        var c = sl.offsetLeft + sl.clientWidth / 2;
        var d = Math.abs(c - center);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };

    var goTo = function (i) {
      if (i < 0) i = loop ? slides.length - 1 : 0;
      if (i > slides.length - 1) i = loop ? 0 : slides.length - 1;
      var sl = slides[i];
      if (!sl) return;
      var left = sl.offsetLeft - (track.clientWidth - sl.clientWidth) / 2;
      track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    };

    var sync = function () {
      var i = current();
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (!loop) {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    function stopAuto() { stopped = true; if (timer) { clearInterval(timer); timer = null; } }
    function startAuto() {
      if (stopped || reduce) return;
      if (section.getAttribute('data-autoplay') !== 'true') return;
      var secs = parseFloat(section.getAttribute('data-interval')) || 5;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (document.hidden) return;
        var i = current();
        if (!loop && i >= slides.length - 1) { clearInterval(timer); timer = null; return; }
        goTo(i + 1);
      }, secs * 1000);
    }

    if (prev) prev.addEventListener('click', function () { stopAuto(); goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { stopAuto(); goTo(current() + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { stopAuto(); goTo(parseInt(d.getAttribute('data-dot'), 10) || 0); });
    });

    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { stopAuto(); goTo(current() + 1); }
      if (e.key === 'ArrowLeft')  { stopAuto(); goTo(current() - 1); }
    });

    section.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
    section.addEventListener('mouseleave', function () { if (!stopped) startAuto(); });
    track.addEventListener('touchstart', function () { if (timer) { clearInterval(timer); timer = null; } }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { startAuto(); }
          else if (timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    } else { startAuto(); }

    sync();
    window.addEventListener('resize', sync, { passive: true });
  }

  function setupVideos(section) {
    var videos = section.querySelectorAll('[data-video]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      var slide = video.closest('[data-slide]');
      var playBtn = slide ? slide.querySelector('[data-play]') : null;
      var soundBtn = slide ? slide.querySelector('[data-sound]') : null;

      var mark = function () {
        if (!slide) return;
        slide.classList.toggle('is-playing', !video.paused);
        slide.classList.toggle('is-unmuted', !video.muted);
      };
      video.addEventListener('play', mark);
      video.addEventListener('pause', mark);
      video.addEventListener('volumechange', mark);

      var tryPlay = function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            video.muted = true;
            var p2 = video.play();
            if (p2 && p2.catch) p2.catch(function () {});
          });
        }
      };

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (video.paused) tryPlay(); else video.pause();
        });
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          video.muted = !video.muted;
          if (!video.muted && video.paused) tryPlay();
          mark();
        });
      }

      if (video.dataset.auto === 'true' && !reduce) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { e.isIntersecting ? tryPlay() : video.pause(); });
          }, { threshold: 0.4 });
          io.observe(video);
        } else { tryPlay(); }
      }
      mark();
    });
  }

  function boot() { document.querySelectorAll('.evx-vr').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-vr');
    if (el) { delete el.dataset.vrReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA MARQUEE — keeps scroll speed consistent (pixels/second) no matter
   how many words are added. Pure vanilla, no libraries. Falls back to the CSS
   duration if JS is unavailable or motion is reduced.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function size(section) {
    if (reduce) return;
    var track = section.querySelector('.evx-mq__track');
    if (!track) return;
    var pps = parseFloat(section.getAttribute('data-pps')) || 60;
    // The animation travels 50% of the track width per cycle.
    var distance = track.scrollWidth / 2;
    if (!distance) return;
    var duration = distance / pps;               // seconds = px / (px per second)
    track.style.animationDuration = duration.toFixed(2) + 's';
  }

  function init(section) {
    if (!section || section.dataset.evxMqReady) return;
    section.dataset.evxMqReady = 'true';

    // Fonts change metrics after load — recalc when they're ready.
    size(section);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { size(section); });
    }
    window.addEventListener('load', function () { size(section); });

    // Recalculate on resize (debounced).
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { size(section); }, 180);
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.evx-mq').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the Theme Editor when re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx-mq');
    if (el) { delete el.dataset.evxMqReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proffessional-hero"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ELEVEIA HERO — modular vanilla JS. No libraries. Runs once per section type;
   iterates over every instance. All config is read from data-* attributes.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.evxReady) return;
    root.dataset.evxReady = 'true';

    var animate  = root.dataset.animate === 'true' && !reduceMotion;
    var parallax = root.dataset.parallax === 'true' && !reduceMotion;

    setupRipple(root);
    if (animate) { setupReveal(root); setupCounters(root); }
    else { showAll(root); }
    if (parallax) setupParallax(root);
  }

  /* --- Scroll reveal via IntersectionObserver ----------------------------- */
  function setupReveal(root) {
    var items = root.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) { showAll(root); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function showAll(root) {
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* --- Counter animation (rating counts up once visible) ------------------ */
  function setupCounters(root) {
    var els = root.querySelectorAll('[data-count]');
    if (!els.length) return;
    var run = function (el) {
      var target   = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
      var start = null, dur = 1400;
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Button ripple ------------------------------------------------------- */
  function setupRipple(root) {
    root.querySelectorAll('[data-evx-ripple]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var rect = btn.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var span = document.createElement('span');
        span.className = 'evx-ripple';
        span.style.width = span.style.height = size + 'px';
        span.style.left = (e.clientX - rect.left - size / 2) + 'px';
        span.style.top  = (e.clientY - rect.top  - size / 2) + 'px';
        btn.appendChild(span);
        setTimeout(function () { span.remove(); }, 620);
      });
    });
  }

  /* --- Very subtle parallax on the media block ---------------------------- */
  function setupParallax(root) {
    var el = root.querySelector('[data-evx-parallax]');
    if (!el || !window.matchMedia('(pointer: fine)').matches) return;
    var ticking = false;
    var apply = function () {
      var rect = el.getBoundingClientRect();
      var mid  = rect.top + rect.height / 2;
      var off  = (mid - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translateY(' + (off * -14).toFixed(2) + 'px)';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }

  /* --- Boot --------------------------------------------------------------- */
  function boot() {
    document.querySelectorAll('.evx').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the Theme Editor when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.evx');
    if (el) { delete el.dataset.evxReady; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
